
<app-main-nav>
  <router-outlet></router-outlet>
</app-main-nav>



<!--<ng-container *ngIf="login_page">-->
<!--  <router-outlet></router-outlet>-->
<!--</ng-container>-->

